import { styled } from "@acko-tech/building-blocks.ui.common";

const gradientText = `
  background: linear-gradient(269deg, #f16262 -10.35%, #743ddc 106.34%);
  background-clip: text;
  color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const BannerContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  padding: 8px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  border-radius: 12px;
  border: 1px solid #e62786;
  background: linear-gradient(
    94deg,
    rgba(74, 222, 128, 0) 39.07%,
    var(--Surface-accent-Pink-pink-200, rgba(236, 72, 153, 0.06)) 61.54%
  );
  cursor: pointer;
  margin: 0 0 24px;
  height: auto;
  position: relative;

  ${(props) => props.styles}
`;

export const BannerCopy = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  padding-right: 28px;
`;

export const BannerTextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
`;

export const BannerTag = styled.span<{ $upgrade?: boolean }>`
  display: flex;
  width: auto;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  background: var(--Maroon-M50, #fbe9f6);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.1px;
`;

export const BannerTagLabel = styled.span<{ $upgrade?: boolean }>`
  display: inline-block;
  background: linear-gradient(269deg, #f16262 -10.35%, #743ddc 106.34%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const BannerHeader = styled.div<{ $compact?: boolean }>`
  width: auto;
  max-width: 100%;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.1px;
  ${gradientText}
`;

export const BannerText = styled.div`
  width: auto;
  max-width: 100%;
  color: var(--text-secondary-n-400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.1px;
`;

export const BannerStrike = styled.s`
  font-weight: 400;
  text-decoration: line-through;
  text-decoration-color: #743ddc;
`;

export const Chevron = styled.img`
  display: block;
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
`;
